import apiPaths from '../api-paths';

export default {
  show({ id }) {
    return axios.get(`${ apiPaths.STAFF }/leaves/${ id }`);
  },
  store({ data }) {
    return axios.post(`${ apiPaths.STAFF }/leaves`, { leave: data });
  },
  update({ data }) {
    return axios.put(`${ apiPaths.STAFF }/leaves/${ data.id }`, { leave: data });
  },
};
